/**
 * Zod schemas for score annotation extension.
 */
import { z } from "zod"

export const scoreConfigSchema = z.object({
  type: z.literal("score"),
  fields: z
    .array(
      z.object({
        key: z.string(),
        label: z.string(),
        type: z.enum(["integer", "categorical", "likert"]),
        required: z.boolean().default(true),
        options: z
          .array(
            z.object({
              value: z.union([z.string(), z.number()]),
              label: z.string()
            })
          )
          .optional(),
        min: z.number().optional(),
        max: z.number().optional(),
        linked_to_instance: z.boolean().default(false)
      })
    )
    .min(1)
})

const scoreValueSchema = z.object({
  field_key: z.string().min(1),
  value_text: z.string().nullable().optional(),
  value_int: z.number().int().nullable().optional(),
  value_float: z.number().nullable().optional(),
  value_bool: z.boolean().nullable().optional()
})

export const createScoreSchema = z.object({
  project_module_id: z.string().min(1),
  series_id: z.string().nullable().optional(),
  linked_annotation_id: z.string().nullable().optional(),
  values: z.array(scoreValueSchema).optional()
})

export const updateScoreSchema = z.object({
  series_id: z.string().nullable().optional(),
  linked_annotation_id: z.string().nullable().optional(),
  values: z.array(scoreValueSchema).min(1).optional()
})
